import { render } from "./Test2.vue?vue&type=template&id=2b78d6a8"
import script from "./Test2.vue?vue&type=script&lang=js"
export * from "./Test2.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/lessons/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__